import {provideApollo} from 'apollo-angular';
import {HttpLink} from 'apollo-angular/http';
import {inject, NgModule} from '@angular/core';
import {InMemoryCache} from '@apollo/client/core';
import {environment} from "../environments/environment";

const uri = environment.SERVER_URL + '/api/v3' ;
@NgModule({
  exports: [],
  providers: [
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        link: httpLink.create({uri}),
        cache: new InMemoryCache({
          addTypename: false
        }),
      };
    }),
  ],
})
export class GraphQLModule {
}
